import {TestScopeTabId} from './components/tabs/types';

export const pageSize = 30;

export const NoTestsMessage: Record<TestScopeTabId, string> = {
	All: 'Nothing to display',
	District: 'You are not linked to your district. Contact customer support to get linked to your district to access any shared tests.',
	MyTests: 'Nothing to display. Click the + icon above to create a test of your own.',
};